import Cookies from 'js-cookie';

const dialog = document.getElementById('dialog');
const closeDialogButton = document.getElementById('close-dialog');
const cookieName = themeData.modal_cookie;

function openDialog() {
  dialog.showModal();
  document.documentElement.classList.add('no-scroll');
}

function closeDialog() {
  dialog.close();
  document.documentElement.classList.remove('no-scroll');
  Cookies.set(cookieName, 'dismissed', { expires: 365, path: '' });
}

if (dialog && cookieName) {
  if (Cookies.get(cookieName)) {
    closeDialog();
  } else {
    document.addEventListener('DOMContentLoaded', openDialog);
  }

  closeDialogButton.addEventListener('click', closeDialog);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDialog();
    }
  });
}
